<template lang="pug">
aside.cart-vue
  header.header
    span.label Part #:
    span.title {{ configID }}
  table.pricing
    thead
      tr
        th(scope="col", width="100%") Quantity
        th(scope="col") Price
    tbody
      tr
        th(scope="row") 1-10
        td ${{ Number(price.oneToFive).toFixed(2)}}
      tr
        th(scope="row") 11-24
        td ${{ Number(price.sixToTen).toFixed(2)}}
      tr
        th(scope="row") 25-50
        td ${{ Number(price.elevenToTwentyFive).toFixed(2)}}

  form.add(v-if="isValid")
    label.label(for="qty") Quantity
    .control
      input#qty(
        v-model="quantity",
        type="text",
        inputmode="numeric",
        min="0",
        step="1",
        pattern="[0-9]+"
      )
      .ticker
        button(type="button", @click.stop.prevent="change(1)") +
        button(type="button", @click.stop.prevent="change(-1)") &ndash;
      button(type="button", @click.stop.prevent="add()") Add to cart
    .order-total
      span Total order
      strong {{ formattedOrderTotal }}
    .minimum-order-error(v-if="minimumOrderError", role="alert") Minimum order amount is $500.

  .action
    button(type="button", @click.stop.prevent="print")
      i.glyph-print
      span Print Datasheet
    button(type="button", @click.stop.prevent="share")
      i.glyph-email
      span Share

  .notes
    span.label Note:
    div(v-html="cart.copy")
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Cart",
        props: ["configID", "title", "price", "emailBody", "emailTopic", "isValid"],
  data() {
    return {
      quantity: 1,
      minimumOrderError: false,
    };
  },
  computed: {
      ...mapGetters(["cart"]),
    normalizedQuantity() {
      const quantity = parseInt(this.quantity, 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
    },
    activeUnitPrice() {
      if (this.normalizedQuantity <= 10) return Number(this.price.oneToFive) || 0;
      if (this.normalizedQuantity <= 24) return Number(this.price.sixToTen) || 0;
      return Number(this.price.elevenToTwentyFive) || 0;
    },
    orderTotal() {
      return this.normalizedQuantity * this.activeUnitPrice;
    },
    formattedOrderTotal() {
      return this.orderTotal.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  methods: {
    change(delta) {
      if (delta < 0 && this.quantity < 1) return;
      this.quantity = this.quantity + delta;
    },
    async add() {
      this.minimumOrderError = false;
      if (this.orderTotal < 500) {
        this.minimumOrderError = true;
        return;
      }

      const configID = this.$route.params.product;
      if (!configID) return this.$router.replace({ path: "/" });

      if (typeof window.track_load === "function") {
        //window.track_load(window.location.href, `Add to Cart - ${configID}`);
      }

      const length = this.$route.query.length;
      const delay = this.$route.query.delay;
      fetch(`${this.$root.submitTo}/${configID}?length=${length}&delay=${delay}&quantity=${this.quantity}`, {
          method: 'POST',
          body: {}
      })
          .then(response => response.json())
          .then(data => {
              $(AjaxCart.success_process(data));
          }).catch(function (error){
              $(AjaxCart.ajaxFailure());
      });
    },
    preparePrint() {
      document.documentElement.classList.add("printingProductSheet");
    },
    print() {
      window.print();
    },
    destroyPrint() {
      document.documentElement.classList.remove("printingProductSheet");
    },
    share() {
      const share = document.createElement("a");        
        share.href = `mailto:?to=&body=` + this.emailBody + `&subject=${this.emailTopic}`;
      share.click();
    },
  },
  watch: {
    quantity() {
      this.minimumOrderError = false;
      let { quantity } = this;
      if (!quantity) return (this.quantity = 0);
      quantity = parseInt(quantity);
      if (this.quantity !== quantity) this.quantity = quantity;
    },
  },
  created() {
    window.addEventListener("beforeprint", this.preparePrint);
    window.addEventListener("afterprint", this.destroyPrint);
  },
  beforeDestroy() {
    window.removeEventListener("beforeprint", this.preparePrint);
    window.removeEventListener("afterprint", this.destroyPrint);
  },
};
</script>


<style lang="scss">
//print styles

@media print {
  @page {
    size: landscape;
    margin: 0mm;
  }
  .header {
    display: none !important;
    height: 0 !important;
  }
  .printingProductSheet {
    //undo some basic page styling
    body,
    #page {
      background: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    // hide everything with visibility so we can unset it later
    * {
      visibility: hidden !important;
    }
    // display none on things that take up space
    .configuration-title,
    .section,
    .bill-of-materials,
    .rail,
    .part-number-search,
    .footer {
      display: none !important;
      height: 0;
    }
    .drawing {
      max-width: 80%;
    }

    //reset the things we want visible
    .configuration .sheet {
      background: $white !important;
    }
    .configuration .sheet,
    .configuration .sheet * {
      visibility: visible !important;
    }
    .drawing {
      padding-top: 0;
      padding-bottom: 0;
    }
    .main {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.cart-vue {
  display: flex;
  flex-direction: column;
  table {
    width: auto;
  }
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0.75rem;
  border-bottom: 1px solid $lightGray;
  margin: 0 0 1.5rem;

  .label {
    font-size: 0.875rem;
    text-transform: uppercase;
    font-weight: 700;
    line-height: 1;
    margin: 0 0 0.5rem;
  }

  .title {
    font-size: 0.875rem;
    text-transform: uppercase;
    margin: 0;
  }
}

.pricing {
  border-collapse: collapse;
  margin: 0 1rem 1.5rem;
  padding: 0;
  font-size: 0.8rem;
  text-align: left;

  tbody {
    tr {
      border-bottom: 1px solid $lightGray;
      th,
      td {
        font-weight: 400;
        padding: 0.75rem 0;
      }
      td {
        white-space: nowrap;
      }
    }
  }
}

.add {
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  margin: 0 0 2rem;
  label {
    font-size: 0.875rem;
    font-weight: 700;
    margin: 0 0 1rem;
    line-height: 0;
  }

  .control {
    display: flex;
    gap: 0.3875rem;
    flex: 0 0 auto;
    box-sizing: border-box;
  }

  input {
    appearance: none;
    border: 2px solid $lightGray;
    border-radius: 0;
    background: 0;
    padding: 1rem;
    font-size: 1rem;
    line-height: 1;
    flex: 1 3 100%;
    width: auto;
    height: auto;
    min-width: 0;
    text-align: center;
    margin: 0;
  }

  .ticker {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    gap: 0.25rem;

    button {
      color: $black;
      background: $lightGray;
      flex: 1 0 0;
      padding: 0 0.5rem;
      line-height: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }

  button {
    cursor: pointer;
    appearance: none;
    background: $red;
    border: none;
    border-radius: 0;
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1;
    flex: 1 2 100%;
    color: $white;
    white-space: nowrap;
    text-transform: uppercase;
  }

  .order-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.75rem;
    padding: 0.75rem 1rem;
    border: 1px solid $lightGray;
    border-radius: 0.375rem;
    font-size: 0.875rem;

    span {
      color: $darkGray;
      font-weight: 700;
    }

    strong {
      font-size: 1rem;
    }
  }

  .minimum-order-error {
    margin-top: 0.5rem;
    color: $red;
    font-size: 0.8rem;
    font-weight: 700;
  }
}

.action {
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  margin: 0;
  border-top: 1px solid $lightGray;
  border-bottom: 1px solid $lightGray;
  //gap: 1rem;

  button {
    display: flex;
    appearance: none;
    background: transparent;
    color: $black;
    border: none;
    outline: none;
    //gap: 0.5rem;
    padding: 0;
    cursor: pointer;
    transition: 0.125s ease;
    margin-bottom: 1rem;

    &:hover {
      color: $red;
      background: transparent;
    }
    i {
      margin-right: 0.5rem;
    }

    span {
      text-transform: uppercase;
      font-weight: 700;
      font-size: 0.8rem;
    }
  }
}

.notes {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;                 
  font-size: 0.8rem;
  

  .label {
    font-weight: 700;
    line-height: 1;
    margin: 0 0 0.25rem;
    text-transform: uppercase;
  }

  div {
    &::v-deep {
      & > *:last-child {
        margin-top: 0;
      }
      *:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.notes a {
  color: #004E7D;
}
</style>
